<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        getEmailValidation,
        getPasswordValidation,
        goToURL,
        showError,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        user,
        createUser,
        createAccount,
        loggedInDoctorDetail,
    } from "../../../stores";

    import { PasswordInput } from "../../../Components/Common/index.svelte";

    export let updatePhase = () => {};
    export let personalDetails = {};

    let accountObj = {},
        isCreatingAccount = false;

    let showPassword = false,
        showConfirmPassword = false,
        error;

    const loginDetails = {};

    $: isSubmitDisabled =
        _getSubmitBtnDisable(
            accountObj,
            isValidEmail,
            isPwdMatched,
            isValidPwd,
        ) || isCreatingAccount;

    $: isValidEmail = accountObj.email
        ? getEmailValidation(accountObj.email)
        : true;

    $: isValidPwd = getPasswordValidation(accountObj.password);

    $: isPwdMatched =
        accountObj.password && accountObj.confirmPassword
            ? accountObj.password === accountObj.confirmPassword
            : true;

    onMount(() => {
        accountObj = {};

        // if ($createUser.id) _resetCreateUser();
    });

    const signUp = async () => {
        isCreatingAccount = true;

        await apiMethods.postMethod
            .signUp(accountObj)
            .then(async (res) => {
                if (res.id) await signIn(res);
                else if (res.error)
                    _handleCreateAccountError(res.error, accountObj);
                else
                    _handleCreateAccountError(
                        "Failed to attempt creating account, please contact support...",
                    );
            })
            .catch((err) =>
                _handleCreateAccountError(
                    "Failed to attempt creating account, please contact support...",
                ),
            );

        isCreatingAccount = false;
    };

    const signIn = async (response) => {
        const data = {
            email: response.email,
            password: accountObj.password,
        };

        await apiMethods.postMethod
            .logIn(data)
            .then((res) => {
                if (res.id) _handleLogin(res);
                else if (res.error) _handleCreateAccountError(res.error);
                else
                    _handleCreateAccountError(
                        "Failed to log in, please contact support...",
                    );
            })
            .catch((err) =>
                _handleCreateAccountError(
                    "Failed to log in, please contact support...",
                ),
            );
    };

    const goToSignIn = (loginDetails = {}) => {
        if (loginDetails)
            localStorage.setItem(
                "TciTempUserDetail",
                JSON.stringify(loginDetails),
            );

        goToURL("/");
    };

    const clearError = (id) => {
        let el = document.getElementById(`${id}`);

        el.style.outline = "";
    };

    // HELPER FUNCTIONS
    const _getSubmitBtnDisable = (
        obj,
        isValidEmail,
        isMatchedPwd,
        isValidPwd,
    ) => {
        return (
            !obj.email ||
            !obj.password ||
            !obj.confirmPassword ||
            !isMatchedPwd ||
            !isValidEmail ||
            !isValidPwd
        );
    };

    const _handleLogin = async (response) => {
        $user.token = response.token;
        $createUser.token = response.token;
        $createUser.refreshToken = response.refreshToken;
        $createUser.expiration = response.expiration;
        $createUser.id = response.id;
        $createUser.name = response.name;
        $createUser.role = response.role;
        $createUser.email = accountObj.email;
        $createUser.pwd = accountObj.password;

        personalDetails.createdUserId = response.id;
        personalDetails.email = accountObj.email;
        personalDetails.verifiedEmail = response.verifiedEmail;
        personalDetails.verifiedPhone = response.verifiedPhone;

        await apiMethods.getMethod.getUserById(response.id).then((res) => {
            personalDetails.userAccounts = res.userAccounts;
            $createAccount = { ...res };
        });

        if (
            response.role == 2 &&
            $createAccount.userAccounts &&
            $createAccount.userAccounts.length
        ) {
            const accountId = res.userAccounts.find((acc) => acc.id).id;
            await apiMethods.getMethod.getAccountById(accountId).then((res) => {
                $loggedInDoctorDetail = { ...res };
                personalDetails = {
                    ...$loggedInDoctorDetail,
                    email: $createAccount.email,
                    verifiedPhone: $createAccount.verifiedPhone,
                    verifiedEmail: $createAccount.verifiedEmail,
                    createdUserId: $createAccount.id,
                };
            });
        } else if (
            $createAccount.userAccounts &&
            $createAccount.userAccounts.length == 1
        )
            await apiMethods.getMethod
                .getAccountById($createAccount.userAccounts[0].id)
                .then((res) => {
                    personalDetails = {
                        ...personalDetails,
                        ...res,
                    };
                });

        if (!personalDetails.verifiedEmail) updatePhase(2);
        else if (!personalDetails.verifiedPhone) updatePhase(3);
        else if (
            !personalDetails.userAccounts ||
            personalDetails.userAccounts.length == 1
        ) {
            if (!personalDetails.providers) updatePhase(4);
            else if (!personalDetails.signatureApproved) updatePhase(7);
        } else updatePhase(8);
    };

    const _keepShowPasswordStatus = () => {
        let el = document.getElementById("createAccountPwdInput");
        if (showPassword) el.type = "text";
        else el.type = "password";
    };

    const _toggleShowPassword = () => {
        showPassword = !showPassword;
        _keepShowPasswordStatus();
    };

    const _keepShowConfirmPasswordStatus = () => {
        let el = document.getElementById("createAccountConfirmPwdInput");
        if (showConfirmPassword) el.type = "text";
        else el.type = "password";
    };

    const _toggleShowConfirmPassword = () => {
        showConfirmPassword = !showConfirmPassword;
        _keepShowConfirmPasswordStatus();
    };

    const _handleCreateAccountError = (err, responseData) => {
        if (err && err.toLowerCase() != "user exists") error = err;
        else {
            error =
                "It looks like you have already started signing up. Please login using your email and password to continue the onboarding process.";

            loginDetails.email = responseData.email;
            loginDetails.password = responseData.password;
        }
        showError(error, onErrorClose, true);
    };

    const onErrorClose = () => {
        if (loginDetails.email) goToSignIn(loginDetails);
    };
</script>

<div class="flex flex-col items-center">
    <p class="text-[32px] font-bold text-primary">Create an Account</p>
</div>

<form on:submit|preventDefault={signUp} novalidate class="w-full">
    <div class="flex flex-1 flex-col gap-y-4">
        <div class="flex flex-col gap-y-2">
            <label
                for="emailAddress"
                class="leading-7 text-sm text-gray-600 font-bold text-[16px]"
            >
                Email Address
            </label>

            <input
                type="email"
                id="createAccountEmailInput"
                name="emailAddress"
                class="input input-sm border outline-2"
                autocomplete="off"
                bind:value={accountObj.email}
            />

            {#if !isValidEmail}
                <p class="error text-error">Invalid Email Address</p>
            {/if}
        </div>

        <div class="flex flex-col gap-y-2">
            <label
                for="password"
                class="leading-7 text-sm text-gray-600 font-bold text-[16px]"
            >
                Password
            </label>

            <PasswordInput bind:value={accountObj.password} isRequired />
        </div>

        <div class="flex flex-col gap-y-2">
            <label
                for="confirmPassword"
                class="leading-7 text-sm text-gray-600 font-bold text-[16px]"
            >
                Confirm Password
            </label>

            <PasswordInput
                bind:value={accountObj.confirmPassword}
                pwdValue={accountObj.password}
                isRequired
                isConfirm
            />

            <!-- {#if !isPwdMatched}
                <p class="error text-error">Password does not match</p>
            {/if} -->
        </div>
    </div>

    {#if isCreatingAccount}
        <button
            class="btn btn-md btn-secondary text-white flex-none border-none w-full mt-4 loading cursor-not-allowed"
        >
            Submitting...
        </button>
    {:else}
        <button
            class={`btn btn-md btn-secondary text-white flex-none w-full mt-4 ${
                isCreatingAccount ? "loading" : ""
            }`}
            disabled={isSubmitDisabled}
            on:click|preventDefault={signUp}
        >
            {isCreatingAccount ? "Submitting" : "Submit"}
        </button>
    {/if}
</form>

<p class="flex gap-x-2 text-[16px]">
    <span class="text-primary">Already have an account?</span>
    <span
        class="text-primary font-bold cursor-pointer hover:underline"
        on:click|preventDefault={goToSignIn}
    >
        Login
    </span>
</p>

<style>
    .error::before {
        content: "*";
    }
</style>
